import React, {
  useContext,
  useEffect,
  useRef,
  useCallback,
} from 'react';
import { useLazyQuery } from '@apollo/client';
import MatchingSetSlider from './MatchingSetSlider/MatchingSetSlider';
import ProductPageContext from '../../contexts/ProductPageContext';
import GET_MATCHING_SETS from './queries';
import MatchingSetSkeleton from './MatchingSetSkeleton/MatchingSetSkeleton';

export default function MatchingSetsWidget() {
  const { collectionData, tmntData } = useContext(ProductPageContext);
  const activeKic = collectionData?.activeProduct?.kicId;

  const [fetchSets, { data, loading }] = useLazyQuery(
    GET_MATCHING_SETS,
    { batch: true },
  );

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (activeKic && !isInitialMount.current) {
      fetchSets({
        variables: {
          kicId: activeKic,
        },
      });
    } else {
      isInitialMount.current = false;
    }
  }, [
    activeKic,
    fetchSets,
  ]);

  const sets = data?.matchingSets !== undefined ? data.matchingSets
    : collectionData.matchingSets || [];

  const handleMatchingSetClick = useCallback((product, element) => {
    const quickviewData = {
      collectionId: String(product.collectionId),
      productId: String(product.productId),
      returnFocus: element,
      faceout: 'prod',
      productViewMethod: 'recommendation-matching set',
      pageViewMethod: 'recommendation-matching set',
    };

    document.dispatchEvent(new CustomEvent('quickview:mfe:openModal', { detail: quickviewData }));
  }, []);

  if (!sets.length && !loading) return null;

  return (
    <div className="matching-sets-widget" data-testid="matching-sets-widget">
      <h3 className="matching-sets-widget__title h3" data-type-style="h3">
        {tmntData.matchingSetPdpHeader?.value}
      </h3>

      {loading ? (
        <div className="matching-sets-widget__loading">
          <MatchingSetSkeleton count={3} />
        </div>
      ) : (
        <div className="matching-sets-widget__slider">
          <MatchingSetSlider
            sets={sets}
            tmntData={tmntData}
            handleMatchingSetClick={handleMatchingSetClick}
          />
        </div>
      )}
    </div>
  );
}
